import { createContext, useContext, useState, useEffect } from "react";
import { useApi } from "./ApiProvider";

const UserContext = createContext();

export default function UserProvider({ children }) {
  const [user, setUser] = useState();
  const api = useApi();

  const [userNotifications, setUserNotifications] = useState([]);
  const [globalNotifications, setGlobalNotifications] = useState([]);

  useEffect(() => {
    (async () => {
      if (api.isAuthenticated()) {
        const response = await api.get("/api/auth/me");

        if (response.success) {
          setUser(response.user);
        } else {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    })();
  }, [api]);

  const login = async (user) => {
    const response = await api.post("/api/auth/login", user);
    if (response.success) {
      localStorage.setItem("user", response.token);
      const me = await api.get("/api/auth/me");
      if (me.success) {
        setUser(me.user);
      } else {
        setUser(null);
      }
    }
    return response;
  };

  const update = async (user) => {
    const response = await api.put("/api/auth/me/update", user);
    if (!response.error) {
      const me = await api.get("/api/auth/me");
      if (me.success) {
        setUser(me.user);
      } else {
        setUser(null);
      }
    }
    return response;
  };

  const logout = async () => {
    const response = await api.post("/api/auth/logout");
    if (!response.error) {
      setUser(null);
      localStorage.removeItem("user");
    }
    return response;
  };

  useEffect(() => {
    (async () => {
      const response = await api.get(`/api/notifications/${user ? user._id : "0"}`);
      if (response.success) {
        setUserNotifications(response.userNotifications);
        setGlobalNotifications(response.globalNotifications);
      }
    })();
  }, [user]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        update,
        login,
        userNotifications,
        globalNotifications,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
